import DatePicker, {
  RangePickerProps as BaseRangePickerProps,
} from 'antd/lib/date-picker'
import locale from 'antd/lib/date-picker/locale/ja_JP'
import 'moment/locale/ja'

const { RangePicker: BaseRangePicker } = DatePicker

export type RangePickerProps = Omit<
  BaseRangePickerProps,
  'locale' | 'picker'
> & {
  picker: 'date' | 'week' | 'month' | 'quarter' | 'year'
}

export const RangePicker = ({
  picker = 'date',
  ...props
}: RangePickerProps): JSX.Element => (
  <>
    <BaseRangePicker locale={locale} picker={picker} {...props} />
  </>
)
